/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_TeamInputs */

const th_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีมเหย้า`)
};

const en_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const ja_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホーム`)
};

const zh_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主队`)
};

const es_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local`)
};

const pt_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandante`)
};

const id_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuan rumah`)
};

const fr_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domicile`)
};

const tl_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tumatanggap`)
};

const vi_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chủ nhà`)
};

const ko_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`홈`)
};

const de_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heim`)
};

const ru_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хозяева`)
};

const tr_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ev sahibi`)
};

const it_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casa`)
};

const pl_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gospodarz`)
};

const uk_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Господарі`)
};

const hi_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेज़बान`)
};

const ar_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صاحب الأرض`)
};

const ms_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuan rumah`)
};

const bn_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ঘরের দল`)
};

const zh_tw2_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主隊`)
};

const zh_hk2_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主隊`)
};

const ur_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`میزبان`)
};

const fa_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`میزبان`)
};

const sw_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwenyeji`)
};

const nl_home_team = /** @type {(inputs: Home_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thuis`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Home_TeamInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_team = /** @type {((inputs?: Home_TeamInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_TeamInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_home_team(inputs)
	if (locale === "ja") return ja_home_team(inputs)
	if (locale === "zh") return zh_home_team(inputs)
	if (locale === "es") return es_home_team(inputs)
	if (locale === "pt") return pt_home_team(inputs)
	if (locale === "id") return id_home_team(inputs)
	if (locale === "fr") return fr_home_team(inputs)
	if (locale === "tl") return tl_home_team(inputs)
	if (locale === "vi") return vi_home_team(inputs)
	if (locale === "ko") return ko_home_team(inputs)
	if (locale === "de") return de_home_team(inputs)
	if (locale === "ru") return ru_home_team(inputs)
	if (locale === "tr") return tr_home_team(inputs)
	if (locale === "it") return it_home_team(inputs)
	if (locale === "pl") return pl_home_team(inputs)
	if (locale === "uk") return uk_home_team(inputs)
	if (locale === "hi") return hi_home_team(inputs)
	if (locale === "ar") return ar_home_team(inputs)
	if (locale === "ms") return ms_home_team(inputs)
	if (locale === "bn") return bn_home_team(inputs)
	if (locale === "zh-TW") return zh_tw2_home_team(inputs)
	if (locale === "zh-HK") return zh_hk2_home_team(inputs)
	if (locale === "ur") return ur_home_team(inputs)
	if (locale === "fa") return fa_home_team(inputs)
	if (locale === "sw") return sw_home_team(inputs)
	if (locale === "nl") return nl_home_team(inputs)
	return en_home_team(inputs)
});